module.exports = __webpack_public_path__ + "img/types.5de71fec.png";